import React from 'react';
import { ArtworkTile } from '../ui';
import { StoryWorld } from './storyWorldModel';

export const TILE_SIZES = '(min-width: 1441px) 240px, (min-width: 1024px) 320px, (min-width: 768px) 240px, 180px';

interface StoryWorldTileProps {
  world: StoryWorld;
  to: string;
  metadata?: string[];
  duration?: string | null;
  status?: string;
  loading?: 'eager' | 'lazy';
  'data-testid'?: string;
}

/**
 * One story world as one activation target. A serialized book renders as a
 * 4:3 tile with its cover; a single story as a 1:1 tile with its artwork.
 * The destination is the existing immersive view through `?story=`.
 */
const StoryWorldTile: React.FC<StoryWorldTileProps> = ({ world, to, metadata, duration, status, loading = 'lazy', 'data-testid': testId }) => {
  const first = world.chapters[0];
  const book = world.serialized;
  const artwork = book
    ? { src: first.book_thumbnail_url || first.thumbnail_url, srcSet: first.book_thumbnail_srcset || first.thumbnail_srcset, sizes: TILE_SIZES }
    : { src: first.thumbnail_url, srcSet: first.thumbnail_srcset, sizes: TILE_SIZES };
  const lines = metadata ?? (book ? [`${world.chapters.length} chapters available`] : [first.theme || 'A bedtime adventure']);
  return (
    <ArtworkTile
      title={world.title}
      aspectRatio={book ? '4/3' : '1/1'}
      artwork={artwork}
      metadata={lines}
      duration={duration || undefined}
      status={status}
      to={to}
      loading={loading}
      data-testid={testId}
    />
  );
};

export default StoryWorldTile;
